import React from "react";
import { FaRobot, FaCode, FaTrophy, FaCalendarAlt } from "react-icons/fa";

const highlights = [
  { icon: FaRobot, text: "Real Robotics Hardware" },
  { icon: FaCode, text: "Hands-On Coding" },
  { icon: FaTrophy, text: "Competition Pathway" },
];

const FutureEngineersAd = () => {
  return (
    <section className="py-16 px-4 bg-[#0d1117]">
      <div className="max-w-6xl mx-auto">
        <div className="rounded-2xl overflow-hidden flex flex-col lg:flex-row border border-white/10">

          {/* Left: content panel with fep-hero as background */}
          <div
            className="lg:w-3/5 relative flex flex-col justify-center p-8 md:p-12"
          >
            {/* background image + overlay */}
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{ backgroundImage: "url('/images/fep-hero.png')" }}
            />
            <div className="absolute inset-0 bg-[#0d1117]/80" />

            {/* content */}
            <div className="relative">
              <h2 className="text-3xl md:text-4xl font-extrabold text-white leading-tight mb-3">
                Future Engineers{" "}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-400">
                  Programme
                </span>
              </h2>

              <p className="text-blue-300 italic text-base mb-4">
                Equipping young minds to engineer the world ahead.
              </p>

              <p className="text-gray-400 text-base leading-relaxed mb-7 max-w-lg">
                A hands-on Coding and Robotics programme for ages 8 to 18.
                Children build, programme, and compete with real robots, applying
                maths, physics, and logic in every session. Delivered by Ikusasa
                Technology Solutions.
              </p>

              <div className="flex flex-wrap gap-5 mb-8">
                {highlights.map(({ icon: Icon, text }) => (
                  <div key={text} className="flex items-center gap-2 text-gray-300 text-sm">
                    <Icon className="text-blue-400 text-lg" />
                    <span>{text}</span>
                  </div>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row gap-3">
                <a
                  href="https://fep-future-engineers.netlify.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-blue-500 hover:bg-blue-600 text-white font-bold text-center px-7 py-3 rounded-full transition duration-300 transform hover:scale-105"
                >
                  Learn More
                </a>
                <a
                  href="https://fep-future-engineers.netlify.app/enroll"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block border border-white/30 hover:border-white text-white font-semibold text-center px-7 py-3 rounded-full transition duration-300"
                >
                  Enrol Your Child
                </a>
              </div>
            </div>
          </div>

          {/* Right: stats + events panel */}
          <div className="lg:w-2/5 bg-gradient-to-br from-blue-600 to-indigo-700 p-8 md:p-12 flex flex-col justify-center items-center text-center gap-5">
            <FaRobot className="text-white/20 text-[6rem]" />

            <div className="space-y-3 w-full max-w-xs">
              {[
                { value: "Ages 8–18", label: "All age groups" },
                { value: "10–40 wks", label: "Flexible duration" },
                { value: "3 Tracks", label: "Explorers · Builders · Engineers" },
              ].map(({ value, label }) => (
                <div key={label} className="bg-white/10 rounded-xl px-5 py-3 text-white">
                  <p className="text-xl font-extrabold">{value}</p>
                  <p className="text-white/70 text-xs mt-0.5">{label}</p>
                </div>
              ))}
            </div>

            {/* Enrol pill */}
            <a
              href="https://fep-future-engineers.netlify.app/enroll"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full max-w-xs bg-white/10 border border-white/20 hover:border-white/40 rounded-xl px-5 py-3 text-white transition duration-200"
            >
              <p className="font-extrabold text-sm">Enrol Your Child</p>
              <p className="text-white/70 text-xs mt-0.5">November cohort now enrolling · Saturdays</p>
            </a>

            {/* Holiday Bootcamp pill */}
            <a
              href="https://fep-future-engineers.netlify.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full max-w-xs bg-orange-500 hover:bg-orange-400 text-white rounded-xl px-5 py-3 transition duration-200"
            >
              <div className="flex items-center justify-center gap-2">
                <FaCalendarAlt className="text-white text-sm" />
                <p className="font-extrabold text-sm">Next Holiday Bootcamp</p>
              </div>
              <p className="text-white/80 text-xs mt-0.5">Enrolments closed · next bootcamp: summer holidays</p>
            </a>
          </div>

        </div>
      </div>
    </section>
  );
};

export default FutureEngineersAd;
